import { createSelector } from "reselect";

import { AppState } from "@shared/interfaces";

const selectEvaluation = (state: AppState) => state.evaluation;

export const getEvalRunsList = () => createSelector(selectEvaluation, (state) => state.runs);
export const getEvalRunsTotal = () => createSelector(selectEvaluation, (state) => state.runsTotal);
export const getEvalRunsFilter = () => createSelector(selectEvaluation, (state) => state.filter);
export const getEvalRun = () => createSelector(selectEvaluation, (state) => state.run);
export const getEvalCategories = () => createSelector(selectEvaluation, (state) => state.categories);
export const getIsEvalRunning = () => createSelector(selectEvaluation, (state) => state.isRunning);
